import React from 'react';
import BottomSection from '../components/BottomSection';
import newsHero from '../assets/images/news-hero.png';
import newsFeature from '../assets/images/news-feature.png';
import newsCoverage from '../assets/images/news-coverage.png';
import newsPage1 from '../assets/images/news-page1.jpg';
import { useSeo } from '../seo';

type NewsPageProps = {
  getInternalHref: (href: string) => string;
  onNavigate: (href: string) => void;
};

function NewsPage({ getInternalHref, onNavigate }: NewsPageProps) {
  useSeo('news');

  return (
    <main className="join-us-page">
      <section className="join-us-section">
        <img className="join-us-image" src={newsHero} alt="价探新闻中心页面头图" />
      </section>

      <section className="join-us-section news-title-section"  style={{ marginTop: '5%' }}>
        <div className="news-title-block">
          <h1>新闻中心</h1>
          <p>NEWS</p>
        </div>
      </section>

      <section className="join-us-section"  style={{ marginTop: '-3%' }}>
        <a
          href="https://cn.chinadaily.com.cn/a/202602/03/WS6981b3d6a310942cc499e142.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="join-us-image" src={newsFeature} alt="价探新闻中心页面展示二" />
        </a>
      </section>

      <section className="join-us-section">
        <img className="join-us-image" src={newsCoverage} alt="价探新闻中心页面展示三" />
      </section>

      <section className="join-us-section">
        <a
          href={getInternalHref('/news/douyin-baike-6')}
          onClick={(event) => {
            event.preventDefault();
            onNavigate('/news/douyin-baike-6');
          }}
        >
          <img className="join-us-image" src={newsPage1} alt="价探新闻中心页面展示四" />
        </a>
      </section>

      <BottomSection />
    </main>
  );
}

export default NewsPage;
